import {
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  KProperty1ca4yb4wlo496 as KProperty1,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ContainerElementjaaooy2agvhc as ContainerElement } from './Element.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { removeLastOrNull3odnlbetbttd4 as removeLastOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { split2t92a14m1lc15 as split } from './ElementWriter.ext.mjs';
import { KiteUiCoroutineScopeHelpers25rj47zs39igb as KiteUiCoroutineScopeHelpers } from './KiteUiCoroutineScopeHelpers.mjs';
import { Companion_getInstance252uiobns9yoh as Companion_getInstance } from '../models/Rect.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_safeInsets(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_safeInsets_$ref_ujbsw9();
  return safeInsets$delegate.setValue_jr48c5_k$(_this__u8e3s4, getPropertyCallableRef('safeInsets', 1, tmp, tmp_0, _set_safeInsets_$ref_eyot1f()), _set____db54di);
}
function get_safeInsets(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_safeInsets_$ref_ujbsw9();
  return safeInsets$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('safeInsets', 1, tmp, tmp_0, _set_safeInsets_$ref_eyot1f()));
}
var safeInsets$delegate;
function set_popoverParent(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverParent_$ref_xfiq5t();
  return popoverParent$delegate.setValue_jr48c5_k$(_this__u8e3s4, getPropertyCallableRef('popoverParent', 1, tmp, tmp_0, _set_popoverParent_$ref_fvsfiz()), _set____db54di);
}
function get_popoverParent(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverParent_$ref_xfiq5t();
  return popoverParent$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('popoverParent', 1, tmp, tmp_0, _set_popoverParent_$ref_fvsfiz()));
}
var popoverParent$delegate;
function set_popoverCloser(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverCloser_$ref_xuz76p();
  return popoverCloser$delegate.setValue_jr48c5_k$(_this__u8e3s4, getPropertyCallableRef('popoverCloser', 1, tmp, tmp_0, _set_popoverCloser_$ref_fgbyi3()), _set____db54di);
}
function get_popoverCloser(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverCloser_$ref_xuz76p();
  return popoverCloser$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('popoverCloser', 1, tmp, tmp_0, _set_popoverCloser_$ref_fgbyi3()));
}
var popoverCloser$delegate;
function set_popoverKeepOpen(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverKeepOpen_$ref_o2wcvo();
  return popoverKeepOpen$delegate.setValue_jr48c5_k$(_this__u8e3s4, getPropertyCallableRef('popoverKeepOpen', 1, tmp, tmp_0, _set_popoverKeepOpen_$ref_xnhg74()), _set____db54di);
}
function get_popoverKeepOpen(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_popoverKeepOpen_$ref_o2wcvo();
  return popoverKeepOpen$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('popoverKeepOpen', 1, tmp, tmp_0, _set_popoverKeepOpen_$ref_xnhg74()));
}
var popoverKeepOpen$delegate;
function get_dismissableDialogStack(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp = KProperty1();
  return dismissableDialogStack$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('dismissableDialogStack', 1, tmp, _get_dismissableDialogStack_$ref_s8muzi(), null));
}
var dismissableDialogStack$delegate;
var ValueClass;
function Value() {
  if (ValueClass === VOID) {
    class $ {
      constructor(value) {
        this.value_1 = value;
      }
      get_1q7qtt_k$(context, property) {
        return this.value_1;
      }
      toString() {
        return 'Value(value=' + toString(this.value_1) + ')';
      }
      hashCode() {
        return this.value_1 == null ? 0 : hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Value()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Value');
    ValueClass = $;
  }
  return ValueClass;
}
var LazyClass;
function Lazy() {
  if (LazyClass === VOID) {
    class $ {
      constructor(init) {
        this.init_1 = init;
      }
      get_1q7qtt_k$(context, property) {
        return this.init_1(context);
      }
      toString() {
        return 'Lazy(init=' + toString_0(this.init_1) + ')';
      }
      hashCode() {
        return hashCode(this.init_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Lazy()))
          return false;
        if (!equals(this.init_1, other.init_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Lazy');
    LazyClass = $;
  }
  return LazyClass;
}
var ContextAddonClass;
function ContextAddon() {
  if (ContextAddonClass === VOID) {
    class $ {
      constructor(init) {
        return new.target.new_com_lightningkite_kiteui_views_ContextAddon_qtrztn_k$(init);
      }
      static new_com_lightningkite_kiteui_views_ContextAddon_qtrztn_k$(init) {
        var $this = createThis(this);
        $this.init_1 = init;
        return $this;
      }
      static new_com_lightningkite_kiteui_views_ContextAddon_1otaba_k$(value) {
        return this.new_com_lightningkite_kiteui_views_ContextAddon_qtrztn_k$(new (Value())(value));
      }
      static new_com_lightningkite_kiteui_views_ContextAddon_o9gbhm_k$(init) {
        return this.new_com_lightningkite_kiteui_views_ContextAddon_qtrztn_k$(new (Lazy())(init));
      }
      getValue_o7pe7q_k$(thisRef, property) {
        var tmp = property.callableName;
        return thisRef.addons_1.getOrPut_ppgj9u_k$(tmp, () => this.init_1.get_1q7qtt_k$(thisRef, property));
      }
      setValue_jr48c5_k$(thisRef, property, value) {
        thisRef.addons_1.set_b9w55f_k$(property.callableName, value);
      }
    }
    initMetadataForClass($, 'ContextAddon');
    ContextAddonClass = $;
  }
  return ContextAddonClass;
}
function contextAddon(init) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  return ContextAddon().new_com_lightningkite_kiteui_views_ContextAddon_1otaba_k$(init);
}
function lazyContextAddon(init) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  return ContextAddon().new_com_lightningkite_kiteui_views_ContextAddon_o9gbhm_k$(init);
}
function closePopovers(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp0_safe_receiver = get_popoverCloser(_this__u8e3s4);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  set_popoverCloser(_this__u8e3s4, null);
  var tmp1_safe_receiver = get_popoverParent(_this__u8e3s4);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_context_h02k06_k$();
  if (tmp2_safe_receiver == null)
    null;
  else {
    closePopovers(tmp2_safe_receiver);
  }
}
function pushDismissableDialog(_this__u8e3s4, dismiss) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var stack = get_dismissableDialogStack(_this__u8e3s4);
  stack.add_utx5q5_k$(dismiss);
  return () => {
    stack.remove_cedx0m_k$(dismiss);
    return Unit_instance;
  };
}
function popoverWriter(_this__u8e3s4, overlay, popoverRoot, close) {
  popoverRoot = popoverRoot === VOID ? false : popoverRoot;
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp0_safe_receiver = get_popoverCloser(_this__u8e3s4.get_context_h02k06_k$());
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  set_popoverCloser(_this__u8e3s4.get_context_h02k06_k$(), close);
  var writer = new (popoverWriter$writer$1())(overlay);
  var tmp = writer.get_context_h02k06_k$();
  var tmp1_safe_receiver = isInterface(_this__u8e3s4, ContainerElement()) ? _this__u8e3s4 : null;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    if (!popoverRoot) {
      tmp_1 = tmp1_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  set_popoverParent(tmp, tmp_0);
  set_popoverCloser(writer.get_context_h02k06_k$(), null);
  set_popoverKeepOpen(writer.get_context_h02k06_k$(), 0);
  return writer;
}
function keepPopoverOpen(_this__u8e3s4, lifecycle) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var _unary__edvuaz = get_popoverKeepOpen(_this__u8e3s4);
  set_popoverKeepOpen(_this__u8e3s4, _unary__edvuaz + 1 | 0);
  onRemove(lifecycle, () => {
    var _unary__edvuaz = get_popoverKeepOpen(_this__u8e3s4);
    set_popoverKeepOpen(_this__u8e3s4, _unary__edvuaz - 1 | 0);
    return Unit_instance;
  });
}
function closeSiblingPopovers(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp0_safe_receiver = get_popoverCloser(_this__u8e3s4);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  set_popoverCloser(_this__u8e3s4, null);
}
function dismissTopDialog(_this__u8e3s4) {
  _init_properties_ViewContextExtensions_kt__afzhxo();
  var tmp0_elvis_lhs = removeLastOrNull(get_dismissableDialogStack(_this__u8e3s4));
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var top = tmp;
  top();
  return true;
}
function _get_safeInsets_$ref_ujbsw9() {
  return constructCallableReference((p0) => get_safeInsets(p0), 1, 0, 108);
}
function _set_safeInsets_$ref_eyot1f() {
  return constructCallableReference((p0, p1) => {
    set_safeInsets(p0, p1);
    return Unit_instance;
  }, 2, 0, 109);
}
function _get_popoverParent_$ref_xfiq5t() {
  return constructCallableReference((p0) => get_popoverParent(p0), 1, 0, 110);
}
function _set_popoverParent_$ref_fvsfiz() {
  return constructCallableReference((p0, p1) => {
    set_popoverParent(p0, p1);
    return Unit_instance;
  }, 2, 0, 111);
}
function _get_popoverCloser_$ref_xuz76p() {
  return constructCallableReference((p0) => get_popoverCloser(p0), 1, 0, 112);
}
function _set_popoverCloser_$ref_fgbyi3() {
  return constructCallableReference((p0, p1) => {
    set_popoverCloser(p0, p1);
    return Unit_instance;
  }, 2, 0, 113);
}
function _get_popoverKeepOpen_$ref_o2wcvo() {
  return constructCallableReference((p0) => get_popoverKeepOpen(p0), 1, 0, 114);
}
function _set_popoverKeepOpen_$ref_xnhg74() {
  return constructCallableReference((p0, p1) => {
    set_popoverKeepOpen(p0, p1);
    return Unit_instance;
  }, 2, 0, 115);
}
function _get_dismissableDialogStack_$ref_s8muzi() {
  return constructCallableReference((p0) => get_dismissableDialogStack(p0), 1, 0, 116);
}
var popoverWriter$writer$1Class;
function popoverWriter$writer$1() {
  if (popoverWriter$writer$1Class === VOID) {
    class $ {
      constructor($overlay) {
        this.$$delegate_0__1 = split($overlay);
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      willAddChild_hz2iwc_k$(element) {
        this.$$delegate_0__1.willAddChild_hz2iwc_k$(element);
      }
      addChild_2qpft2_k$(element) {
        this.$$delegate_0__1.addChild_2qpft2_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    popoverWriter$writer$1Class = $;
  }
  return popoverWriter$writer$1Class;
}
var properties_initialized_ViewContextExtensions_kt_vqh4wi;
function _init_properties_ViewContextExtensions_kt__afzhxo() {
  if (!properties_initialized_ViewContextExtensions_kt_vqh4wi) {
    properties_initialized_ViewContextExtensions_kt_vqh4wi = true;
    safeInsets$delegate = contextAddon(new (Constant())(_Constant___init__impl__v45mub(Companion_getInstance().ZERO_1)));
    popoverParent$delegate = contextAddon(null);
    popoverCloser$delegate = contextAddon(null);
    popoverKeepOpen$delegate = contextAddon(0);
    // Inline function 'kotlin.collections.mutableListOf' call
    var tmp$ret$0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    dismissableDialogStack$delegate = contextAddon(tmp$ret$0);
  }
}
//region block: exports
export {
  closePopovers as closePopoversckn4u815mr3s,
  closeSiblingPopovers as closeSiblingPopovers3i0hc71zpkpil,
  dismissTopDialog as dismissTopDialog36m1xp4el7vem,
  keepPopoverOpen as keepPopoverOpen28p29d3izy3mk,
  lazyContextAddon as lazyContextAddon10t74vogc7n59,
  get_popoverCloser as get_popoverCloser4tnhy9srbgxw,
  set_popoverCloser as set_popoverCloser5swh04w6mwwp,
  get_popoverKeepOpen as get_popoverKeepOpenyttrvw1n7ako,
  get_popoverParent as get_popoverParent2ywfrf2fh1f87,
  popoverWriter as popoverWriter2910ws87tq4dw,
  pushDismissableDialog as pushDismissableDialog1yvcdbsxh0ht9,
  get_safeInsets as get_safeInsets2hm6tkuvmrp7k,
  set_safeInsets as set_safeInsets1p7xqcp7roimu,
};
//endregion

//# sourceMappingURL=ViewContextExtensions.mjs.map
